// check if given string is alpha numeric
const isAlphaNumericDash = (str, allowSpace=false) => {
    // is not alpha numeric if empty string
    if (str.length == 0){
      return false; 
    }
    // check for non alpha numeric characters
    var code;
    for (let i = 0; i < str.length; i++) {
      code = str.charCodeAt(i);
      if (allowSpace && !(code > 47 && code < 58) && // numeric (0-9)
        !(code > 64 && code < 91) && // upper alpha (A-Z)
        !(code > 96 && code < 123) && // lower alpha (a-z)
        code != 32 && // space char
        code != 45  // '-' char
      ) { 
        return false;
      }
      else if (!allowSpace && !(code > 47 && code < 58) && // numeric (0-9)
        !(code > 64 && code < 91) && // upper alpha (A-Z)
        !(code > 96 && code < 123) && // lower alpha (a-z)
        code != 45 // '-' char
      ) { 
        return false; 
      }
    }
    return true;
};

export default isAlphaNumericDash;